<template>
    <div class="ui-table">
        <div class="table">
            <ui-table
                :data="contents"
                :loading="false"
                :select-column-menu="false"
                name="tablePayment"
                tr-component="launch/control/payment-table-line"
                not-found-text="Não foi possível encontrar nenhuma regra."
                not-found-icon="fa fa-file-contract"
            />
        </div>
    </div>
</template>

<script>
    import { uiTable } from '@/components/ui'

    export default {
        name: 'ui-launch-control-table-payment',

        components: {
            uiTable,
        },

        props: {
            contents: {
                type: Array,
                required: true
            }
        }
    }
</script>

<style lang="stylus" scoped>
	@import 'styles.styl';
</style>